import { makeStyles, Typography } from '@material-ui/core'
import { Spinner } from 'components'
import React from 'react'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  loading: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  description: {
    marginBottom: theme.spacing(3)
  },
  content: {
  }
}))


export type TabContentProps = {
  isLoading?: boolean
  description?: string
  children?: React.ReactNode
}

const TabContent = ({ ...props }: TabContentProps) => {
  const classes = useStyles()

  if (props.isLoading === true) {
    return (
      <div className={classes.loading} >
        <Spinner />
      </div>
    )
  }

  return (
    <div className={classes.root}>
      {props.description && <Typography className={classes.description} variant={'body1'}>{props.description}</Typography>}
      <div className={classes.content}>
        {props.children}
      </div>
    </div>
  )
}

export default TabContent
